import type * as Sentry from '@sentry/browser'

/**
 * Moves a message event's synthetic stack to `threads`, so Sentry titles the issue by its message.
 *
 * Sentry gives a captured message the stack it was captured with as a synthetic exception, and titles a
 * synthetic exception by its top function, which is always our capture wrapper.
 */
export function moveMessageStackToThreads(event: Sentry.ErrorEvent): void {
  const [syntheticException, ...rest] = event.exception?.values ?? []
  if (!event.message || !syntheticException?.mechanism?.synthetic || rest.length) {
    return
  }

  event.threads = { values: [{ stacktrace: syntheticException.stacktrace, current: true, crashed: false }] }
  delete event.exception
}
